import React from 'react';
import PropTypes from 'prop-types';

import { translate } from 'helpers/Translate';

const Informations = ({ content, iconInformation }) => (
    <div className="informations">
        <div className="panel panel--tips">
            {iconInformation && (
                <div className="tip tip--infos">
                    <span className="icon-info_outline tip__icon tip__icon--infos" />
                    <span className="tip__title tip__title--infos">{translate('Information')}</span>
                </div>
            )}
            {content}
        </div>
    </div>
);

Informations.displayName = 'Informations';

Informations.propTypes = {
    content: PropTypes.node,
    iconInformation: PropTypes.bool,
};

/**
 * Informations Functional Component.
 */
export default Informations;
